import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const ConnectAuthContext = createContext(null);

export const useConnectAuth = () => useContext(ConnectAuthContext);

const getStoredToken = () => localStorage.getItem("altura_connect_token");
const setStoredToken = (token) => { if (token) localStorage.setItem("altura_connect_token", token); };
const clearStoredToken = () => localStorage.removeItem("altura_connect_token");

export const ConnectAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = getStoredToken();
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await axios.get(`${API}/api/connect/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(data);
    } catch (err) {
      console.error("Auth check failed:", err.message);
      clearStoredToken();
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/connect/auth/login`, { email, password });
    if (data.access_token) setStoredToken(data.access_token);
    setUser(data);
    return data;
  };

  const changePassword = async (newPassword) => {
    const token = getStoredToken();
    await axios.post(`${API}/api/connect/auth/change-password`, { new_password: newPassword }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setUser(prev => prev ? { ...prev, must_change_password: false } : prev);
  };

  const logout = async () => {
    const token = getStoredToken();
    try {
      await axios.post(`${API}/api/connect/auth/logout`, {}, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
    } catch { /* logout endpoint failure is non-critical - user is logged out locally regardless */ }
    clearStoredToken();
    setUser(false);
  };

  return (
    <ConnectAuthContext.Provider value={{ user, loading, login, logout, checkAuth, changePassword }}>
      {children}
    </ConnectAuthContext.Provider>
  );
};
